import EmbeddedBackButton from './EmbeddedBackButton';

export default EmbeddedBackButton;
